import { ActivityStatus, CrudStatus } from '../common/enums';

export interface IRootState<IService = any> {
  activityStatus?: ActivityStatus;
  crudActionStatus?: CrudStatus;
  service?: IService;
  loaders?: Map<string,boolean>
}

export class RootState<IService = any> implements IRootState {
  /**
   *
   */
  activityStatus: ActivityStatus;
  crudActionStatus: CrudStatus;
  service: IService;
  loaders?: Map<string,boolean>
  configuration: {
    activityStatus: ActivityStatus,
    err: any | null
    info: {
      agency_name: string
      logo: string
      logo_white: string
      sign_up_roles: { id: number, name: string }[]
    } | null
  }
  constructor(opt: IRootState) {
    this.activityStatus = opt.activityStatus;
    this.crudActionStatus= CrudStatus.NoAction
    this.service = opt.service!;
    this.configuration = {
      activityStatus: ActivityStatus.NoActivity,
      info: null,
      err: null,
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/root-state.store.ts